namespace Portico.Services {

	import Inject = Portico.Decorators.Inject;
	import Service = Portico.Decorators.Service;

	import pm = Portico.Models;
	import pme = Portico.Models.Enterprise;
	import pmi = Portico.Models.Interfaces;
	import pms = Portico.Models.Setup;

    export interface IPortalDataGroupService {
        delete(portalDataGroup: pms.PortalDataGroup): angular.IPromise<boolean>;
		getByPortalId(portalId: string): angular.IPromise<pms.PortalDataGroup[]>;
		getHistory(id: string, spinner?: string): angular.IPromise<pms.PortalDataGroup[]>;
        save(portalDataGroup: pms.PortalDataGroup): angular.IPromise<pms.PortalDataGroup>;
    }

    @Service('app', 'portalDataGroupService')
    @Inject('apiService')
    export class PortalDataGroupService implements IPortalDataGroupService {
        constructor(
            private apiService: IApiService
        ) { }

        delete(portalDataGroup: pms.PortalDataGroup): angular.IPromise<boolean> {
            const endpoint = `/portaldatagroup/${portalDataGroup.id}`;

            return this.apiService.deleteItem(endpoint).then((response: boolean) => {
                return response;
            });
        }

		getByPortalId(portalId: string): angular.IPromise<pms.PortalDataGroup[]> {
            const endpoint = `/portaldatagroupbyportalid/${portalId}`;

            return this.apiService.getItem<pms.PortalDataGroup[]>(endpoint).then((response: pms.IPortalDataGroup[]) => {
                const portalDataGroups: pms.PortalDataGroup[] = [];

                for (const portalDataGroup of response) {
                    portalDataGroups.push(new pms.PortalDataGroup(portalDataGroup));
                }

                return portalDataGroups;
            });
        }

		getHistory(id: string, spinner: string = null): angular.IPromise<pms.PortalDataGroup[]> {
			const endpoint = `/portaldatagrouphistory/${id}`;

			return this.apiService.getItem<pms.PortalDataGroup[]>(endpoint, spinner).then((response: pms.PortalDataGroup[]) => {
				const portalDataGroups: pms.PortalDataGroup[] = [];

				for (const portalDataGroup of response) {
					portalDataGroups.push(new pms.PortalDataGroup(portalDataGroup));
				}

				return _.orderBy(portalDataGroups, ['createdOn'], ['desc']);
			});
		}

        save(portalDataGroup: pms.PortalDataGroup): angular.IPromise<pms.PortalDataGroup> {
            const endpoint = `/portaldatagroup`;

            return this.apiService.saveItem<pms.PortalDataGroup, pms.PortalDataGroup>(endpoint, portalDataGroup).then((response: pms.IPortalDataGroup) => {
                return new pms.PortalDataGroup(response);
            });
        }
    }
}